// =====================================================
// 📁 PendingSalesList.tsx
// =====================================================

import { PendingSaleSummary } from '../../../../../types/sale';
import PendingSaleCard from './PendingSaleCard';


interface Props {
  sales: PendingSaleSummary[];
}

const PendingSalesList: React.FC<Props> = ({
  sales,
}) => {
  return (
    <div className="space-y-3">
      {sales.map((sale) => (
        <PendingSaleCard
          key={sale.id}
          sale={sale}
        />
      ))}
    </div>
  );
};

export default PendingSalesList;